import { logger, security } from '@beelday/common'
import { useCallback, useRef } from 'react'
import { needsFreshLogin } from './model/stream-health'

/**
 * Refreshes a login that ran out, or is about to, before a stream opens
 * again. The login is refreshed on a timer, which does not run while a
 * phone's browser is in the background; a stream opened with the old login
 * in its cookie would be refused and closed for good.
 */
export const useFreshLogin = (): (() => Promise<void>) => {
	const auth = security.useAuth()
	const latest = useRef(auth)
	latest.current = auth

	return useCallback(async () => {
		const { tokenState, refresh } = latest.current
		if (
			tokenState.type === 'INVALID_TOKENS' ||
			!needsFreshLogin(tokenState, Date.now())
		) {
			return
		}
		try {
			await refresh(tokenState)
		} catch (error) {
			logger.warn('Could not refresh the login before reopening', error)
		}
	}, [])
}
